import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import truncate from 'truncate';

const NotificationCard = ({ notice }) => {
  return (
    <Fragment>
      <Link
        to={notice.button.link}
        className={`block ${
          notice.isRead ? 'bg-white' : 'bg-cf-005'
        } text-gray-800 px-2 md:px-4 py-2 rounded border-b border-gray-500 hover:bg-cf-100 hover:text-gray-800`}
      >
        <div className="ml-2 md:ml-4">
          <p className="w-2/3 mb-2 font-header pb-1 text-xs md:text-sm hover:text-black">
            {notice.title}
          </p>
          <div className="flex items-center justify-between">
            <div className="md:w-full w-56 mr-2">
              <p
                className="text-tiny md:text-sm"
                dangerouslySetInnerHTML={{
                  __html: truncate(notice.message, 200)
                }}
              ></p>
            </div>
          </div>
        </div>
      </Link>
    </Fragment>
  );
};

export default NotificationCard;
